var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListColorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4219 1.25H2.07812C1.48269 1.25 1 1.73269 1 2.32812V11.6719C1 12.2673 1.48269 12.75 2.07812 12.75H11.4219C12.0173 12.75 12.5 12.2673 12.5 11.6719V2.32812C12.5 1.73269 12.0173 1.25 11.4219 1.25Z",
    stroke: "#2DB2CF",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.80556H11H2.5H1V4.76389H2.5H11H12.5V3.80556ZM12.5 6.68057H11H2.5H1V7.6389H2.5H11H12.5V6.68057ZM11 9.55557H12.5V10.5139H11H2.5H1V9.55557H2.5H11Z",
    fill: "#2DB2CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListColorIcon);
export default __webpack_public_path__ + "static/media/ListColorIcon.d4b90d0fb64c3b8c64fe71b70b57f9df.svg";
export { ForwardRef as ReactComponent };